import React, { createContext, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";
import PropTypes from "prop-types";

export const UserContext = createContext({ user: null, setUser: () => {} });

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const auth = getAuth();
  const db = getDatabase();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const { uid, email } = currentUser;

        try {
          const userRef = ref(db, `landlords/${uid}`);
          const snapshot = await get(userRef);

          if (snapshot.exists()) {
            const landlordData = snapshot.val();
            console.log("Landlord profile loaded:", landlordData);

            setUser({
              uid,
              email,
              ...landlordData,
            });
          } else {
            console.warn("No landlord profile found for UID:", uid);
            setUser({ uid, email });
          }
        } catch (err) {
          console.error("Error fetching landlord profile:", err);
          setUser({ uid, email });
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, [auth, db]);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
